class HeaderActionDropdownComponent extends HTMLElement {
	connectedCallback() {
		this.trigger = this.querySelector('[ref="trigger"]');
		this.panel = this.querySelector('[ref="panel"]');
		this.closedIcon = this.querySelector('[ref="closedIcon"]');
		this.openIcon = this.querySelector('[ref="openIcon"]');

		if (!this.trigger || !this.panel) return;

		this.onTriggerClick = this.onTriggerClick.bind(this);
		this.onDocumentClick = this.onDocumentClick.bind(this);
		this.onEscape = this.onEscape.bind(this);

		this.trigger.addEventListener('click', this.onTriggerClick);
		document.addEventListener('click', this.onDocumentClick);
		document.addEventListener('keydown', this.onEscape);
	}

	disconnectedCallback() {
		this.trigger?.removeEventListener('click', this.onTriggerClick);
		document.removeEventListener('click', this.onDocumentClick);
		document.removeEventListener('keydown', this.onEscape);
	}

	onTriggerClick(event) {
		event.stopPropagation();
		this.toggle();
	}

	onDocumentClick(event) {
		if (!this.panel?.classList.contains('is-open')) return;
		if (!this.contains(event.target)) {
			this.close();
		}
	}

	onEscape(event) {
		if (event.key === 'Escape') {
			this.close();
		}
	}

	toggle() {
		if (!this.panel.classList.contains('is-open')) {
			this.open();
			return;
		}

		this.close();
	}

	open() {
		this.panel.removeAttribute('hidden');
		// Force reflow so the browser registers the non-hidden state before adding the class
		this.panel.offsetHeight;
		this.panel.classList.add('is-open');
		this.trigger.setAttribute('aria-expanded', 'true');
		this.closedIcon?.classList.add('hidden');
		this.openIcon?.classList.remove('hidden');
	}

	close() {
		this.panel.classList.remove('is-open');
		this.trigger.setAttribute('aria-expanded', 'false');
		this.closedIcon?.classList.remove('hidden');
		this.openIcon?.classList.add('hidden');

		const onTransitionEnd = () => {
			this.panel.setAttribute('hidden', '');
			this.panel.removeEventListener('transitionend', onTransitionEnd);
		};
		this.panel.addEventListener('transitionend', onTransitionEnd);

		// Fallback in case transitionend doesn't fire
		setTimeout(() => {
			if (!this.panel.hasAttribute('hidden')) {
				this.panel.setAttribute('hidden', '');
			}
			this.panel.removeEventListener('transitionend', onTransitionEnd);
		}, 350);
	}
}

if (!customElements.get('header-action-dropdown-component')) {
	customElements.define('header-action-dropdown-component', HeaderActionDropdownComponent);
}
